import type { AtlassianUser } from '../../types';
import { safelyParseUserAri } from '../ari';

export const isAtlassianUser = (entity: any): entity is AtlassianUser =>
	entity.__typename === 'AtlassianUser';

export const getAtlassianUserLink = (
	user: AtlassianUser,
	orgHomeUrl: string,
	cloudId: string,
): string | null => {
	const userAri = safelyParseUserAri(user.id);
	if (!userAri) {
		return null;
	}

	return `${orgHomeUrl}/people/${userAri.resourceId}?cloudId=${cloudId}`;
};
